import { RequireAuth } from '@/auth/RequireAuth'
import { DashboardPage } from '@/routes/DashboardPage'
import { LoginPage } from '@/routes/LoginPage'
import { SignUpPage } from '@/routes/SignUpPage'
import { VerifyEmailPage } from '@/routes/VerifyEmailPage'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route element={<RequireAuth />}>
          <Route path="/" element={<DashboardPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
